/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAIcon20Solid = forwardRef('DataChartBarsAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17 3.5a1 1 0 1 0-2 0v13a1 1 0 1 0 2 0v-13Z" }),
        React.createElement("path", { d: "M9 6.5a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0v-10Z" }),
        React.createElement("path", { d: "M5 12a1 1 0 1 0-2 0v4.5a1 1 0 1 0 2 0V12Z" }),
        React.createElement("path", { d: "M12 8a1 1 0 0 1 1 1v7.5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z" })));
});
